import VSpinner from './v-spinner.vue';

export { VSpinner };
export default VSpinner;
